import { SpinnerIcon } from '@phosphor-icons/react';
import classNames from 'classnames';
import { CSSProperties } from 'react';
import styles from './Spinner.module.scss';

type TSpinnerVariant = 'ring' | 'dots' | 'radial';

interface ISpinnerProps {
  size?: number;
  thickness?: number;
  variant?: TSpinnerVariant;
  label?: string;
  className?: string;
}

export function Spinner({ size = 24, thickness = 2, variant = 'radial', label = 'Loading', className }: ISpinnerProps) {
  'use memo';

  if (variant === 'radial') {
    return (
      <span role="status" aria-label={label} className={classNames(styles.radial, className)}>
        <SpinnerIcon size={size} aria-hidden="true" />
      </span>
    );
  }

  if (variant === 'dots') {
    return (
      <div
        role="status"
        aria-label={label}
        className={classNames(styles.dots, className)}
        style={{ '--spinner-size': `${size}px` } as CSSProperties}
      >
        <span className={styles.dot} aria-hidden="true" />
        <span className={styles.dot} aria-hidden="true" />
        <span className={styles.dot} aria-hidden="true" />
      </div>
    );
  }

  return (
    <div
      role="status"
      aria-label={label}
      className={classNames(styles.spinner, className)}
      style={
        {
          '--spinner-size': `${size}px`,
          '--spinner-thickness': `${thickness}px`,
        } as CSSProperties
      }
    />
  );
}
